import type { IconProps } from '.';

/**
 * Filter Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const FilterIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M16 6.00251C15.6022 6.00251 15.2206 6.16054 14.9393 6.44185C14.658 6.72315 14.5 7.10468 14.5 7.50251C14.5 7.90033 14.658 8.28186 14.9393 8.56317C15.2206 8.84447 15.6022 9.00251 16 9.00251C16.3978 9.00251 16.7794 8.84447 17.0607 8.56317C17.342 8.28186 17.5 7.90033 17.5 7.50251C17.5 7.10468 17.342 6.72315 17.0607 6.44185C16.7794 6.16054 16.3978 6.00251 16 6.00251ZM13.55 7.00251C13.6648 6.43736 13.9714 5.92927 14.4179 5.56432C14.8644 5.19937 15.4233 5 16 5C16.5767 5 17.1356 5.19937 17.5821 5.56432C18.0286 5.92927 18.3352 6.43736 18.45 7.00251H21V8.00251H18.45C18.3352 8.56765 18.0286 9.07574 17.5821 9.44069C17.1356 9.80565 16.5767 10.005 16 10.005C15.4233 10.005 14.8644 9.80565 14.4179 9.44069C13.9714 9.07574 13.6648 8.56765 13.55 8.00251H3V7.00251H13.55ZM8 15.0025C7.60218 15.0025 7.22064 15.1605 6.93934 15.4418C6.65804 15.7232 6.5 16.1047 6.5 16.5025C6.5 16.9003 6.65804 17.2819 6.93934 17.5632C7.22064 17.8445 7.60218 18.0025 8 18.0025C8.39782 18.0025 8.77936 17.8445 9.06066 17.5632C9.34196 17.2819 9.5 16.9003 9.5 16.5025C9.5 16.1047 9.34196 15.7232 9.06066 15.4418C8.77936 15.1605 8.39782 15.0025 8 15.0025ZM5.55 16.0025C5.66476 15.4374 5.97136 14.9293 6.41787 14.5643C6.86438 14.1994 7.42332 14 8 14C8.57668 14 9.13562 14.1994 9.58213 14.5643C10.0286 14.9293 10.3352 15.4374 10.45 16.0025H21V17.0025H10.45C10.3352 17.5677 10.0286 18.0757 9.58213 18.4407C9.13562 18.8056 8.57668 19.005 8 19.005C7.42332 19.005 6.86438 18.8056 6.41787 18.4407C5.97136 18.0757 5.66476 17.5677 5.55 17.0025H3V16.0025H5.55Z"
      fill="white"
    />
  </svg>
);

export default FilterIcon;
